import { render } from "./TarotCardSelectPage.vue?vue&type=template&id=b780404a&scoped=true"
import script from "./TarotCardSelectPage.vue?vue&type=script&lang=js"
export * from "./TarotCardSelectPage.vue?vue&type=script&lang=js"

import "./TarotCardSelectPage.vue?vue&type=style&index=0&id=b780404a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b780404a"]])

export default __exports__